// extracted by mini-css-extract-plugin
export var box = "_62-0";
export var check = "_62-1";
export var checkboxButton = "_62-6";
export var checkboxGroup = "_62-5";
export var disabled = "_62-7";
export var ghost = "_62-9";
export var input = "_62-2";
export var label = "_62-4";
export var normal = "_62-8";
export var uncheck = "_62-3";